import React, { useState } from "react";
import {
  SubtitleStyled,
} from './style';
import sendPasswordResetEmail from "services/login/solicitacao-redefinicao-senha/solicitacao-redefinicao-senha";
import {
  ContainerLeftStyled,
  ContainerRightStyled,
  CustomEmailInput,
  ErrorMessageStyled,
  FormGroupStyled,
  H1Styled,
  InputGroupStyled,
  LogoStyled,
  TitleContainerStyled,
} from "../style";
import LoginScreenCarousel from "components/LoginScreenCarousel/login-screen-carousel";
import validator from "validator";
import logo from 'assets/img/logo-fundacred-branco.svg';
import { Helmet } from 'react-helmet';
import Loader from 'components/Login/Loader/Loader';
import { EnumScreenName, IErrorMessageLogin } from "models/login";
import ButtonLogin from "components/ButtonLogin/ButtonLogin";
import { useHistory } from "react-router-dom";
import { useLoginContext } from "context/login-context";

const SolicitacaoRecuperacaoSenha = () => {
  const {
    errorMessage,
    isLoading,
    setErrorMessage,
    setIsLoading,
  } = useLoginContext();
  const history = useHistory();

  const [email, setEmail] = useState<string>('');
  const [showForm, setShowForm] = useState<boolean>(true);
  const isInputValid = email === '' || errorMessage !== '';

  const sendLink = async (event, email) => {
    setIsLoading(true);
    if (email) {
      event.preventDefault();
      try {
        await sendPasswordResetEmail(email);
        setShowForm(false);
      } catch (error) {
        if(error?.response?.status === 404){
          setErrorMessage(IErrorMessageLogin.EMAIL_NAO_CADASTRADO);
        } else {
          setErrorMessage('');
        }
      }
    }
    setIsLoading(false);
  }

  const handleValueEmail = (value) => {
    if (!validator.isEmail(value) && value !== '') {
      setErrorMessage(IErrorMessageLogin.EMAIL_FORMATO_INVALIDO);
    } else {
      setErrorMessage('');
    }
    setEmail(value);
  }

  return (
    <>
      <Helmet>
        <title>Fundacred - Home</title>
      </Helmet>
      <ContainerLeftStyled>
        <LogoStyled src={logo} onClick={() => history.push('/login')} />
        <LoginScreenCarousel />
      </ContainerLeftStyled>

      <ContainerRightStyled screen={showForm ? EnumScreenName.TELA_RECUPERAR_SENHA : EnumScreenName.TELA_LINK_ENVIADO}>
        {showForm ? (
          <FormGroupStyled>
            <TitleContainerStyled>
              <H1Styled>Redefinir senha</H1Styled>
              <SubtitleStyled>Por favor, insira seu e-mail para receber o link de redefinição de senha</SubtitleStyled>
            </TitleContainerStyled>
            <InputGroupStyled show={true}>
              <CustomEmailInput
                id='input-email-recuperacao'
                label='E-mail'
                fullWidth
                InputProps={{
                  disableUnderline: true,
                }}
                value={email}
                onChange={(event) => handleValueEmail(event.target.value)}
                error={!!(errorMessage && errorMessage !== IErrorMessageLogin.ERRO_SERVICO)}
              />
              <ErrorMessageStyled>{errorMessage}</ErrorMessageStyled>
            </InputGroupStyled>

            <ButtonLogin
              id='botao-enviar-link-recuperacao'
              label='Enviar link'
              onClick={(event) =>
                sendLink(event, email)
              }
              disabled={isInputValid || isLoading}
              margin='40px 0 0 0'
              alignSelf='flex-end'
              type='with-icon'
              icon={isLoading ? <Loader className='loader' /> : ''}
            />
          </FormGroupStyled>
        ) : (
          <TitleContainerStyled margin='0'>
            <H1Styled>O link para redefinir senha foi enviado com sucesso</H1Styled>
            <SubtitleStyled>
              Enviado para {email}
            </SubtitleStyled>
          </TitleContainerStyled>
        )}
      </ContainerRightStyled>
    </>
  )
}

export default SolicitacaoRecuperacaoSenha;